import axios from 'axios';

const url = 'http://localhost:6005';
// // const url = 'http://elearning.nu-pie.com/api';
// export const baseUrl = `${url}`;

export const postGone = (newPost) => axios.post(url + '/create_gone', newPost);
export const fetchGone = async () => await fetch(url + '/gone');

// export const loginUser = (newPost) => axios.post(url + '/login_user', newPost);
// export const fetchUsers = async () => await fetch(baseUrl + '/users');

// export const getGrades = async () => await fetch(url + '/grades');
// export const postGrades = (newPost) => axios.post(baseUrl + '/create_grade', newPost);
// export const updateGrade = (id, resData) => axios.patch(`${url + '/update_grade'}/${id}`, resData);
// export const deleteGrade = (id) => axios.delete(`${url + '/delete_grade'}/${id}`);

// export const getSubjects = async () => await fetch(url + '/subjects');

// export const getQuestions = async () => await fetch(url + '/questions');

// export const getAssignments = async () => await fetch(url + '/assignments');
// export const postAssignments = (newPost) => axios.post(baseUrl + '/create_assignment', newPost);

// export const uploadImageFile = async (newPost) => await axios.post(url + '/upload_image', newPost);

// export const getSections = async () => await fetch(url + '/sections');
// export const postSections = (form) => axios.post(baseUrl + '/create_section', form);